import { ApolloError } from '@apollo/client'

import { IncidentQuery } from '@/graphql/generated/operations'
import { IncidentStatus } from '@/graphql/generated/schemas'

const ERROR_CODE_ACCESS_DENIED = 'incident.access.denied'

export const getOrigin = () =>
  typeof window !== 'undefined' && window.location.origin
    ? window.location.origin
    : ''

export const getTabColors = (isSelected: boolean) => {
  const bgColor = isSelected ? '#5f96f5' : '#e3eefb'
  const hoverBgColor = isSelected ? '#5f96f5' : '#1b253f'
  const iconColor = isSelected ? '#ffffff' : '#3d7fce'
  const hoverIconColor = isSelected ? '#ffffff' : '#5a6c9a'

  return { bgColor, hoverBgColor, iconColor, hoverIconColor }
}

export const getOnticTooltipMessage = (
  incident: IncidentQuery['incident']
): string => {
  if (!incident) return ''

  const isResolved = incident.status === IncidentStatus.Resolved

  if (!isResolved) {
    return 'Incident must be resolved to send to Ontic'
  }

  if (incident.isSentToOntic) {
    return 'Incident has already been sent to Ontic'
  }

  return '' // No message needed when button is enabled
}

/**
 * Checks if an Apollo error contains the 'incident.access.denied' code.
 *
 * @param error - The ApolloError from a GraphQL query
 * @returns `true` if access is denied, `false` otherwise
 */
export const isAccessDeniedCode = (error: ApolloError) => {
  return (
    error?.graphQLErrors?.some(
      (err) => err.extensions?.code === ERROR_CODE_ACCESS_DENIED
    ) ?? false
  )
}
